import { CSSProperties } from 'react'
import cn from 'classnames/bind'

import styles from './plain-time-selector.module.scss'

const cx = cn.bind(styles)

const size = 300
const radius1 = 65
const radius2 = 100
const radius3 = 130
const centerX = size / 2
const centerY = size / 2
const itemSize = 32
const halfOfItemSize = 32 / 2

export interface ClockButtonsCustomCSS extends CSSProperties {
  '--time-selector-item-size': string
  '--time-selector-size': string
}

const cssVariables: ClockButtonsCustomCSS = {
  '--time-selector-item-size': `${itemSize}px`,
  '--time-selector-size': `${size}px`,
}

type Props = {
  className?: string
  currentHours?: number | null
  currentMinutes?: number | null
  onChangeHours?: (hours: number) => void
  onChangeMinutes?: (minutes: number) => void
}

export const PlainTimeSelector = ({
  className,
  currentHours,
  currentMinutes,
  onChangeHours,
  onChangeMinutes,
}: Props) => {
  const hours = Array.from({ length: 12 }, (_, i) => i)
  const minutes = Array.from({ length: 60 }, (_, i) => i)

  return (
    <div className={cx(styles.root, className)} style={cssVariables}>
      <button className={styles.resetMinutes} onClick={() => onChangeMinutes?.(0)}>
        {':00'}
      </button>

      {hours.map((i) =>
        [0, 12].map((offset) => {
          const angle = (i / 12) * 2 * Math.PI - Math.PI / 2
          const radius = offset === 0 ? radius1 : radius2
          const x = centerX + radius * Math.cos(angle) - halfOfItemSize
          const y = centerY + radius * Math.sin(angle) - halfOfItemSize
          const num = i + offset

          return (
            <label key={num} style={{ left: x, top: y }} className={styles.labelHour}>
              <input
                type="radio"
                id={`hours-${num}`}
                name="hours"
                value={num}
                checked={currentHours === num}
                onChange={() => onChangeHours?.(num)}
              />
              <span className={styles.hourVisual}>{num}</span>
            </label>
          )
        }),
      )}

      {minutes.map((i) => {
        const angle = (i / 60) * 2 * Math.PI - Math.PI / 2
        const radius = radius3
        const x = centerX + radius * Math.cos(angle) - halfOfItemSize
        const y = centerY + radius * Math.sin(angle) - halfOfItemSize
        const num = i

        return (
          <label
            key={num}
            style={{ left: x, top: y }}
            className={cx(styles.labelMinute, { current: currentMinutes === num })}
          >
            <input
              type="radio"
              id={`minutes-${num}`}
              name="minutes"
              value={num}
              checked={currentMinutes === num}
              onChange={() => onChangeMinutes?.(num)}
            />
            <span className={styles.minuteVisual}>{String(num).padStart(2, '0')}</span>
          </label>
        )
      })}
    </div>
  )
}
